export default "__VITE_ASSET__DPx4qmOq__"